import { Directive, AfterViewInit, Input } from '@angular/core';
import { MatMenu } from '@angular/material/menu';

@Directive({
  selector: 'mat-menu[mat-menu-action-position]',
})
export class MatMenuPositionDirective implements AfterViewInit {
    @Input('mat-menu-action-position') menuType: string | undefined;
    constructor(private menu: MatMenu) {}

    ngAfterViewInit(): void {
        if (this.menuType === 'unlink') {
            this.menu.overlayPanelClass = `unlink-action`;
        }
    }
}
